/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav.
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
 */

// Material Dashboard 2 PRO React components
// @mui icons
import Icon from "@mui/material/Icon";
// Images
import Users from "./layouts/users/view/Users";
import Locations from "./layouts/locations/view/Locations";
import Products from "./layouts/products/view/Products";
import Doctors from "./layouts/doctors/view/Doctors";
import Sales from "./layouts/sales/view/Sales";
import NewSale from "./layouts/sales/new-sale/NewSale";
import Payouts from "./layouts/payouts/view/Payouts";
import Patients from "./layouts/patients/view/Patients";
import EditSettings from "./layouts/settings/edit-settings/EditSettings";
import Dashboard from "./layouts/dashboard/Dashboard";

export const adminRoutes = [
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Ventas",
    key: "ventas",
    icon: <Icon fontSize="medium">receipt</Icon>,
    route: "/ventas",
    component: <Sales/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Pagos",
    key: "pagos",
    icon: <Icon fontSize="medium">attach_money</Icon>,
    route: "/pagos",
    component: <Payouts/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Doctores",
    key: "doctores",
    icon: <Icon fontSize="medium">person_add</Icon>,
    route: "/doctores",
    component: <Doctors/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Pacientes",
    key: "pacientes",
    icon: <Icon fontSize="medium">face</Icon>,
    route: "/pacientes",
    component: <Patients/>,
    noCollapse: true,
  },
  { type: "divider", key: "divider-1" },
  {
    type: "collapse",
    name: "Productos",
    key: "productos",
    icon: <Icon fontSize="medium">medication</Icon>,
    route: "/productos",
    component: <Products/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Usuarios",
    key: "usuarios",
    icon: <Icon fontSize="medium">person</Icon>,
    route: "/usuarios",
    component: <Users/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sucursales",
    key: "sucursales",
    icon: <Icon fontSize="medium">local_pharmacy</Icon>,
    route: "/sucursales",
    component: <Locations/>,
    noCollapse: true,
  }
];

export const managerRoutes = [
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Nueva Venta",
    key: "nueva-venta",
    icon: <Icon fontSize="medium">point_of_sale</Icon>,
    route: "/ventas/nueva-venta",
    component: <NewSale/>,
    noCollapse: true,
  },
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "Ventas",
    key: "ventas",
    icon: <Icon fontSize="medium">receipt</Icon>,
    route: "/ventas",
    component: <Sales/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Pagos",
    key: "pagos",
    icon: <Icon fontSize="medium">attach_money</Icon>,
    route: "/pagos",
    component: <Payouts/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Doctores",
    key: "doctores",
    icon: <Icon fontSize="medium">person_add</Icon>,
    route: "/doctores",
    component: <Doctors/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Pacientes",
    key: "pacientes",
    icon: <Icon fontSize="medium">face</Icon>,
    route: "/pacientes",
    component: <Patients/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Productos",
    key: "productos",
    icon: <Icon fontSize="medium">medication</Icon>,
    route: "/productos",
    component: <Products/>,
    noCollapse: true,
  },
];

export const operatorRoutes = [
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "Nueva Venta",
    key: "nueva-venta",
    icon: <Icon fontSize="medium">point_of_sale</Icon>,
    route: "/ventas/nueva-venta",
    component: <NewSale/>,
    noCollapse: true,
  },
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "Ventas",
    key: "ventas",
    icon: <Icon fontSize="medium">receipt</Icon>,
    route: "/ventas",
    component: <Sales/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Pacientes",
    key: "pacientes",
    icon: <Icon fontSize="medium">face</Icon>,
    route: "/pacientes",
    component: <Patients/>,
    noCollapse: true,
  },
];
